import { BifrostWeb } from '@seekrtech/bifrost-web'

export const bifrost = new BifrostWeb({
  enableDebug: import.meta.env.MODE !== 'production',
})
